var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _mask, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _mask2, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCs2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 272,
    viewBox: "0 0 272 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.567 199.784H84.3816C83.5792 199.784 83.3276 198.7 84.0481 198.346C88.0914 196.363 90.6541 192.252 90.6541 187.749V163.625H98.6118V187.436C98.6118 192.1 101.359 196.327 105.621 198.222L105.874 198.334C106.622 198.667 106.385 199.784 105.567 199.784Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.922 155.697H78.0262C75.8371 155.697 74.0625 157.472 74.0625 159.661C74.0625 161.85 75.8371 163.625 78.0262 163.625H111.922C114.111 163.625 115.886 161.85 115.886 159.661C115.886 157.472 114.111 155.697 111.922 155.697Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8669 168.166C93.4486 167.022 96.0303 165.878 98.612 164.734V163.853C95.9594 163.777 93.3069 163.701 90.6543 163.625C90.7252 165.139 90.796 166.652 90.8669 168.166Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.801 137.82L136.801 137.82C136.682 137.772 136.554 137.724 136.427 137.678H206.956C208.932 137.678 210.564 136.206 210.818 134.299C210.921 134.652 210.977 135.029 210.977 135.421C210.977 137.485 209.436 139.122 207.578 139.122H138.852C138.236 138.624 137.574 138.131 136.801 137.82Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.928 130.133L206.955 130.132C208.743 130.132 210.232 131.419 210.542 133.116C210.582 133.33 210.602 133.552 210.602 133.779C210.602 135.794 208.97 137.428 206.955 137.428L135.226 137.428",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.885 114.197L139.855 119.167",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.822 126.598L135.379 130.133H177.02L187.59 104.248C187.72 103.928 187.485 103.578 187.139 103.578H159.261",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.646 103.772L187.649 103.766C187.955 103.846 188.295 104.029 188.516 104.452C188.842 105.074 188.711 105.683 188.665 105.86L178.864 129.883H176.854L187.646 103.772Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.672 119.862H150.324L149.714 121.631H148.093C147.895 121.631 147.764 121.424 147.848 121.245L148.427 120.018C148.472 119.923 148.567 119.862 148.672 119.862Z",
    fill: "#0E171E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.773 123.208H174.324C174.696 123.208 174.885 122.94 175.083 122.525L177.278 118.131C177.431 117.531 177.02 117.419 176.668 117.28L172.407 116.017C172.058 115.878 171.442 115.848 171.731 115.202L174.221 108.635C174.479 107.696 173.639 107.696 173.082 107.696H157.463",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.613 123.208H166.529",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.452 114.197L149.395 122.491C149.141 123.206 149.601 123.208 150.228 123.208H151.555",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.13 122.971L156.13 122.971L156.13 122.973C156.139 123.048 156.143 123.127 156.143 123.207C156.143 124.38 155.192 125.331 154.019 125.331C152.845 125.331 151.895 124.38 151.895 123.207C151.895 122.234 152.549 121.413 153.442 121.161L153.443 121.161C153.625 121.11 153.818 121.082 154.019 121.082C155.113 121.082 156.013 121.908 156.13 122.971ZM152.898 123.206C152.898 123.825 153.4 124.328 154.019 124.328C154.638 124.328 155.14 123.825 155.14 123.206C155.14 122.587 154.638 122.085 154.019 122.085C153.4 122.085 152.898 122.587 152.898 123.206Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.189 122.971L171.189 122.971C171.072 121.908 170.172 121.082 169.078 121.082C168.849 121.082 168.628 121.119 168.422 121.186L171.189 122.971ZM171.189 122.971L171.189 122.973M171.189 122.971L171.189 122.973M171.189 122.973C171.198 123.048 171.203 123.127 171.203 123.207C171.203 124.38 170.252 125.331 169.078 125.331C167.905 125.331 166.953 124.38 166.953 123.207C166.953 122.263 167.569 121.462 168.421 121.186L171.189 122.973ZM167.957 123.206C167.957 123.825 168.459 124.328 169.078 124.328C169.697 124.328 170.199 123.825 170.199 123.206C170.199 122.587 169.697 122.085 169.078 122.085C168.459 122.085 167.957 122.587 167.957 123.206Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.714 118.79L176.209 119.932C175.925 119.839 175.746 119.554 175.792 119.253L175.545 119.215L175.792 119.253C175.847 118.904 176.183 118.673 176.528 118.746L176.714 118.79Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.143 114.681L170.057 114.911C169.99 114.894 169.92 114.884 169.848 114.884H168.677C168.454 114.884 168.245 114.971 168.087 115.129L168.087 115.129C167.985 115.231 167.914 115.356 167.875 115.493C167.857 115.555 167.849 115.616 167.846 115.671L167.615 115.668L167.615 115.668L165.13 115.632L165.13 115.632H165.126C164.988 115.632 164.87 115.61 164.807 115.572C164.783 115.557 164.779 115.546 164.777 115.542C164.775 115.536 164.767 115.507 164.786 115.438L166.929 109.701L166.929 109.701L166.931 109.696C167.042 109.379 167.295 109.227 167.524 109.227H171.78C171.929 109.227 172.027 109.244 172.077 109.275C172.094 109.285 172.101 109.295 172.107 109.31C172.113 109.327 172.122 109.365 172.113 109.438L170.143 114.681L170.143 114.681Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.422 109.42C156.209 109.974 154.671 113.749 154.212 113.871L153.807 114.794L157.965 111.454L156.422 109.42Z",
    fill: "#0E171E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M164.769 108.992L159.271 112.344L156.723 108.981H164.585C164.646 108.981 164.709 108.984 164.769 108.992Z",
    fill: "#0E171E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.917 115.675L158.226 112.211L158.808 112.979L158.808 112.979L158.809 112.98C158.906 113.106 159.052 113.178 159.209 113.178C159.3 113.178 159.391 113.153 159.471 113.104L160.789 112.299L162.17 115.649L154.109 115.691C154.109 115.691 154.108 115.691 154.108 115.691C154.041 115.691 153.975 115.686 153.917 115.675Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.164 109.332C165.169 109.382 165.169 109.44 165.162 109.506L163.016 115.261C162.981 115.351 162.948 115.429 162.92 115.495L161.344 111.669L165.124 109.365C165.139 109.355 165.152 109.345 165.164 109.332Z",
    fill: "#0E171E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M167.844 115.943C167.844 116.404 168.217 116.777 168.678 116.777H169.959C170.189 116.777 170.397 116.684 170.549 116.533C170.7 116.382 170.794 116.173 170.794 115.943C170.794 115.836 170.774 115.734 170.736 115.64C170.744 115.685 170.748 115.731 170.748 115.778C170.748 116.008 170.654 116.218 170.503 116.368C170.352 116.519 170.144 116.613 169.913 116.613H168.743C168.282 116.613 167.909 116.239 167.909 115.778C167.909 115.701 167.919 115.627 167.938 115.557C167.878 115.672 167.844 115.804 167.844 115.943Z",
    fill: "#0E171E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.921 115.538C170.865 115.2 170.659 114.923 170.379 114.769C170.223 114.681 170.042 114.631 169.85 114.631H168.679C168.39 114.631 168.118 114.744 167.911 114.948C167.778 115.082 167.682 115.248 167.632 115.429C167.606 115.525 167.594 115.621 167.594 115.716C167.594 115.784 167.601 115.852 167.614 115.918C167.707 116.421 168.148 116.804 168.679 116.804H169.85C170.14 116.804 170.412 116.691 170.616 116.487C170.823 116.281 170.936 116.009 170.936 115.716C170.936 115.656 170.931 115.595 170.921 115.538ZM170.261 116.129C170.15 116.24 170.004 116.301 169.85 116.301H168.679C168.43 116.301 168.221 116.145 168.135 115.925C168.11 115.86 168.097 115.789 168.097 115.716C168.097 115.666 168.102 115.613 168.118 115.563C168.145 115.465 168.196 115.376 168.266 115.306C168.377 115.195 168.523 115.135 168.679 115.135H169.85C169.979 115.135 170.1 115.177 170.198 115.253C170.314 115.336 170.399 115.467 170.425 115.623C170.43 115.653 170.432 115.686 170.432 115.716C170.432 115.873 170.372 116.019 170.261 116.129Z",
    fill: "#0E171E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.455 118.25H165.982C166.106 118.25 166.207 118.149 166.207 118.025V118.022C166.207 117.898 166.106 117.797 165.982 117.797H164.455C164.331 117.797 164.23 117.898 164.23 118.022V118.025C164.23 118.149 164.331 118.25 164.455 118.25Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-1_5775_101889",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.469 118.691H164.97C164.72 118.691 164.517 118.489 164.517 118.239H165.922C165.922 118.489 165.719 118.691 165.469 118.691Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.469 118.691H164.97C164.72 118.691 164.517 118.489 164.517 118.239H165.922C165.922 118.489 165.719 118.691 165.469 118.691Z",
    fill: "#0E171E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.517 118.239V117.739H164.017V118.239H164.517ZM165.922 118.239H166.422V117.739H165.922V118.239ZM165.469 118.191H164.97V119.191H165.469V118.191ZM164.97 118.191C164.996 118.191 165.017 118.212 165.017 118.239H164.017C164.017 118.765 164.444 119.191 164.97 119.191V118.191ZM164.517 118.739H165.922V117.739H164.517V118.739ZM165.422 118.239C165.422 118.212 165.443 118.191 165.469 118.191V119.191C165.995 119.191 166.422 118.765 166.422 118.239H165.422Z",
    fill: "#0E171E",
    mask: "url(#path-24-inside-1_5775_101889)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.548 122.127H146.396H147.548Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M147.548 122.127H146.396",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 122.636H145.68H146.162Z",
    fill: "#0E171E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 122.636H145.68",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M139.793 105.901L136.505 112.911C136.265 113.446 136.657 114.051 137.243 114.051H154.04C154.359 114.051 154.648 113.864 154.778 113.573L162.013 97.4338C162.253 96.8986 161.862 96.2939 161.275 96.2939H147.021",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M142.59 105.902C143.344 106.806 144.098 107.709 144.851 108.613C147.858 108.643 150.865 108.673 153.872 108.704C154.89 107.732 155.907 106.76 156.925 105.788V101.255H153.098C151.928 102.379 150.759 103.502 149.59 104.626H143.315",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M143.551 107.054C147.608 107.015 151.666 106.975 155.723 106.936L153.872 108.704L144.851 108.613L143.551 107.054Z",
    fill: "#0E171E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.256 105.469C151.984 105.298 151.821 105.006 151.846 104.718C151.882 104.321 152.271 103.976 152.758 103.989",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M154.352 105.378C154.031 105.156 153.922 104.743 154.078 104.422C154.21 104.151 154.51 103.985 154.83 104.012",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M143.377 104.626H148.979L148.998 102.097C148.998 102.097 146.038 102.049 144.558 102.024",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.152 104.626C146.167 103.768 146.182 102.91 146.197 102.052",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M145.188 100.294L147.633 100.298L147.643 102.006",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.914 109.752C142.189 110.042 142.621 110.114 142.962 109.934C143.271 109.77 143.453 109.427 143.418 109.068C143.581 109.759 144.201 110.214 144.83 110.162C145.327 110.12 145.769 109.767 145.957 109.263C146.143 109.973 146.832 110.402 147.472 110.276C148.003 110.171 148.427 109.701 148.497 109.114C148.63 109.7 149.154 110.109 149.727 110.093C150.246 110.079 150.71 109.721 150.866 109.205C150.912 109.299 151.152 109.766 151.709 109.957C152.145 110.105 152.519 109.998 152.643 109.957",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M149.384 88.1445H132.588C132.269 88.1445 131.98 88.3317 131.85 88.6225L124.615 104.762C124.375 105.297 124.766 105.901 125.353 105.901H142.149C142.468 105.901 142.757 105.714 142.887 105.423L150.123 89.2843C150.363 88.7491 149.971 88.1445 149.384 88.1445Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.743 98.2248L130.768 98.5923L129.54 95.9869C129.54 95.9869 129.371 95.6837 129.527 95.3678C129.663 95.0917 129.99 94.956 130.288 95.035C130.656 95.1329 131.218 95.5005 131.906 96.6458L134.691 95.9869L142.567 93.681C142.567 93.681 144.31 93.0103 145.767 94.4111C145.99 94.6256 145.98 94.9893 145.75 95.1966C145.38 95.53 144.549 96.0275 142.716 96.7056L139.797 97.6018",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.099 97.2765L134.826 101.491C134.678 101.981 135.202 102.408 135.648 102.157C136.764 101.531 138.593 99.9656 140.681 96.0557",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M134.69 95.9862L133.635 94.8905C133.456 94.7039 133.597 94.3938 133.856 94.4077L139.12 94.6893",
    fill: "#0E171E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M134.69 95.9862L133.635 94.8905C133.456 94.7039 133.597 94.3938 133.856 94.4077L139.12 94.6893",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.186 96.6533H134.916V97.1362H135.186V96.6533Z",
    fill: "#0E171E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M136.592 96.3613H136.322V96.8442H136.592V96.3613Z",
    fill: "#0E171E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.256 95.5039H138.986V95.9868H139.256V95.5039Z",
    fill: "#0E171E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M137.965 95.9863H137.695V96.4692H137.965V95.9863Z",
    fill: "#0E171E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140.814 95.0615H140.545V95.5444H140.814V95.0615Z",
    fill: "#0E171E"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-2_5775_101889",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.066 94.8203H141.797V95.3032H142.066V94.8203Z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M142.066 94.8203H141.797V95.3032H142.066V94.8203Z",
    fill: "#0E171E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M141.797 94.8203V94.3203H141.297V94.8203H141.797ZM142.066 94.8203H142.566V94.3203H142.066V94.8203ZM142.066 95.3032V95.8032H142.566V95.3032H142.066ZM141.797 95.3032H141.297V95.8032H141.797V95.3032ZM141.797 95.3203H142.066V94.3203H141.797V95.3203ZM141.566 94.8203V95.3032H142.566V94.8203H141.566ZM142.066 94.8032H141.797V95.8032H142.066V94.8032ZM142.297 95.3032V94.8203H141.297V95.3032H142.297Z",
    fill: "#0E171E",
    mask: "url(#path-49-inside-2_5775_101889)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M145.222 94.2514C145.223 94.252 145.224 94.2527 145.224 94.2534C145.075 94.5151 144.863 94.6103 144.673 94.6447C144.558 94.6657 144.449 94.6635 144.368 94.6555C144.328 94.6515 144.296 94.6463 144.275 94.6422C144.266 94.6405 144.259 94.6391 144.254 94.638C144.003 94.5526 143.854 94.4427 143.765 94.3392C143.676 94.2349 143.635 94.1237 143.62 94.0183C143.606 93.918 143.615 93.8226 143.63 93.7474C144.157 93.6978 144.57 93.8389 144.86 93.9988C145.019 94.0868 145.141 94.1806 145.222 94.2514Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M178.659 126.494H136.775",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M200.991 129.882H188.457L189.498 128.329L189.498 128.329C190.038 127.522 190.948 127.037 191.92 127.037H197.617C198.63 127.037 199.572 127.564 200.101 128.429L200.101 128.429L200.991 129.882Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M194.773 126.787C197.436 120.069 199.164 115.416 201.827 108.697",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M200.544 103.773C194.621 97.8348 190.231 93.434 184.309 87.4961",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M202.805 108.863C204.441 108.863 205.766 107.537 205.766 105.902C205.766 104.266 204.441 102.94 202.805 102.94C201.17 102.94 199.844 104.266 199.844 105.902C199.844 107.537 201.17 108.863 202.805 108.863Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M185.788 82.6864C183.948 81.3633 181.384 81.7821 180.061 83.6218L178.186 86.5979L179.157 87.3411C179.356 87.2619 179.589 87.2542 179.829 87.3628C180.74 87.7741 181.675 88.2662 182.47 88.877C183.112 89.371 183.457 90.0809 183.941 90.7113C184.049 90.8516 184.095 90.9906 184.1 91.1223L184.309 91.2818L186.723 88.4132C188.046 86.5735 187.628 84.0094 185.788 82.6864Z",
    fill: "#0E171E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M180.78 87.9853L182.358 89.1204C185.439 91.3355 186.141 95.6346 183.926 98.7148L182.868 100.186L170.128 91.0235L171.186 89.5525C173.401 86.4724 177.7 85.7701 180.78 87.9853Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.621 201.409C140.786 201.482 149.6 201.482 158.667 200.726C166.474 199.719 174.282 199.215 181.334 194.43C181.837 194.178 182.593 194.178 183.097 193.674C185.363 192.415 187.882 192.919 189.775 194.469",
    fill: "#0E171E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.621 201.409C140.786 201.482 149.6 201.482 158.667 200.726C166.474 199.719 174.282 199.215 181.334 194.43C181.837 194.178 182.593 194.178 183.097 193.674C185.363 192.415 187.882 192.919 189.775 194.469",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25 199.435C71.7784 200.222 73.0377 199.467 74.297 198.711C74.8007 198.459 75.0525 197.956 74.8007 197.2C74.5488 196.948 74.0451 196.696 73.5414 197.2C72.7858 198.207 73.2895 199.467 74.297 199.97C76.8155 200.978 79.334 201.23 82.1044 200.978C86.134 200.222 90.1636 199.97 94.1933 199.719C103.008 199.215 110.903 200.157 119.722 200.772",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2313 199.365C57.9417 199.229 57.7704 199.101 57.652 199.008C57.3725 198.786 56.7378 198.277 56.2719 197.383C55.6976 196.29 55.7153 195.268 55.7228 194.802C55.743 193.716 56.1409 192.356 56.9191 191.08C56.9645 191.107 57.0249 191.122 57.0879 191.115C57.3574 191.08 57.6269 191.052 57.8963 191.034C57.4833 191.636 57.1786 192.286 56.9846 192.971C56.1888 195.789 57.5236 198.3 58.2313 199.365Z",
    fill: "#0E171E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1008 199.905C59.6072 199.819 59.2143 199.721 58.897 199.623C58.9247 199.547 58.9146 199.461 58.8642 199.393C58.3253 198.663 56.6378 196.054 57.4715 193.11C57.6831 192.357 58.0407 191.651 58.5419 191.004C58.8415 190.994 59.1388 190.997 59.4359 191.009C59.2193 191.415 59.0405 191.835 58.902 192.266C57.9072 195.369 59.1715 198.318 60.1008 199.905Z",
    fill: "#0E171E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M62.302 200.154C61.6775 200.114 61.1359 200.058 60.6701 199.993C60.6801 199.937 60.6701 199.88 60.6398 199.827C59.7508 198.363 58.4058 195.457 59.3805 192.42C59.5341 191.944 59.7407 191.48 59.995 191.042C60.3728 191.072 60.7481 191.118 61.1233 191.178C60.7229 191.714 60.4081 192.296 60.1915 192.901C60.1789 192.923 60.1688 192.951 60.1638 192.976C60.0479 193.306 59.9623 193.639 59.9095 193.979V193.981C59.9044 193.999 59.9019 194.016 59.8994 194.037V194.052C59.8893 194.092 59.8842 194.135 59.8792 194.178C59.4913 197.202 61.5389 199.439 62.302 200.154Z",
    fill: "#0E171E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7083 191.529C62.4313 191.765 62.1341 191.974 61.8218 192.156C61.512 192.337 61.1871 192.491 60.8496 192.614C61.104 192.06 61.4113 191.612 61.6807 191.279H61.6833C62.0283 191.35 62.3708 191.433 62.7083 191.529Z",
    fill: "#0E171E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6118 193.223C61.123 193.072 61.6166 192.86 62.0776 192.591C62.5082 192.339 62.9112 192.042 63.2739 191.704C63.6466 191.825 64.0042 191.961 64.3442 192.107C63.9337 192.555 63.3091 193.079 62.4352 193.429C61.8106 193.681 61.1306 193.81 60.4531 193.807C60.4959 193.603 60.5488 193.409 60.6118 193.223Z",
    fill: "#0E171E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6777 188.269C61.355 187.229 63.2742 186.922 65.1026 187.101C64.7299 187.282 64.3748 187.501 64.0474 187.755C63.7754 187.967 63.521 188.206 63.2893 188.468C62.1006 188.282 60.8917 188.214 59.6777 188.269Z",
    fill: "#0E171E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6221 193.898C63.6622 193.48 64.38 192.84 64.8282 192.326C65.2765 192.535 65.6946 192.764 66.0824 193.004C65.3395 193.465 64.2565 193.963 62.8965 194.112C62.5389 194.15 62.1838 194.162 61.8262 194.15C62.0982 194.087 62.3652 194.001 62.6221 193.898Z",
    fill: "#0E171E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4262 198.363C66.0585 198.937 65.7109 199.522 65.3835 200.114C65.3609 200.154 65.3508 200.197 65.3508 200.237C65.2803 200.24 65.2097 200.24 65.1393 200.24C64.3282 200.24 63.6055 200.224 62.9607 200.192C62.9632 200.116 62.9305 200.041 62.8676 199.988C62.7819 199.917 62.5074 199.678 62.1699 199.3C62.855 199.25 63.5375 199.154 64.2048 199.013C64.9579 198.852 65.7033 198.635 66.4262 198.363Z",
    fill: "#0E171E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5104 188.35C64.8934 188.051 65.3198 187.809 65.7782 187.629C65.864 187.596 65.9336 187.544 65.986 187.48C66.1124 187.504 66.2383 187.53 66.3635 187.558C66.2416 187.641 66.1223 187.727 66.0058 187.816C65.6921 188.053 65.3947 188.315 65.119 188.599C64.8851 188.537 64.6501 188.48 64.4142 188.428C64.4461 188.401 64.4781 188.375 64.5104 188.35Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3544 194.467C60.9286 194.596 61.5129 194.659 62.0947 194.659C62.3792 194.659 62.6664 194.644 62.9484 194.614C64.2228 194.475 65.4644 194.022 66.5524 193.299C66.9478 193.561 67.308 193.828 67.6329 194.09C66.6658 195.12 65.4745 195.941 64.18 196.467C63.1071 196.903 61.9713 197.142 60.8026 197.177C60.4727 196.397 60.2662 195.482 60.3544 194.467Z",
    fill: "#0E171E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6126 188.614L66.6126 188.614L66.6132 188.614C66.9121 188.386 67.2307 188.181 67.5618 188.003L67.5618 188.003L67.5626 188.003C67.5969 187.984 67.6281 187.962 67.6561 187.938C67.7882 187.986 67.9188 188.036 68.0476 188.089C67.8809 188.221 67.722 188.362 67.5724 188.51L67.5724 188.51L67.5715 188.511C67.3591 188.723 67.1614 188.952 66.9848 189.198C66.7351 189.102 66.4827 189.013 66.2286 188.929C66.3529 188.819 66.481 188.714 66.6126 188.614Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8923 198.565C61.7404 198.361 61.5878 198.136 61.4436 197.891C62.4836 197.802 63.497 197.559 64.4636 197.167L64.4638 197.167C65.7938 196.627 67.0209 195.8 68.0345 194.763C68.1772 194.89 68.3113 195.016 68.4369 195.139C68.2268 195.396 68.0231 195.655 67.8229 195.917L67.8221 195.918C67.4518 196.408 67.0902 196.908 66.7441 197.423C65.8758 197.795 64.9704 198.082 64.0489 198.275L64.0489 198.275L64.0477 198.275C63.341 198.427 62.6162 198.523 61.8923 198.565Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1264 191.206C66.068 191.769 67.9275 192.602 69.6767 193.695C69.4742 193.916 69.2757 194.141 69.0811 194.368C68.5048 193.809 67.7653 193.188 66.8624 192.602C66.836 192.582 66.8101 192.567 66.796 192.559C66.2545 192.211 65.6548 191.876 64.9945 191.573C64.9718 191.56 64.9512 191.552 64.9419 191.548C64.6801 191.429 64.408 191.314 64.1264 191.206Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2794 189.223L68.2794 189.223L68.2805 189.222C68.5045 188.998 68.7522 188.798 69.0187 188.626C69.0413 188.612 69.0624 188.596 69.0819 188.579C69.4561 188.782 69.8066 189.005 70.1273 189.242C69.9211 189.375 69.7278 189.528 69.5505 189.698C69.3965 189.844 69.2555 190.003 69.1296 190.172C68.7417 189.965 68.3465 189.772 67.945 189.593C68.0499 189.463 68.1616 189.339 68.2794 189.223Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5995 190.052C61.1135 189.748 59.5874 189.589 58.0586 189.589C58.3633 189.269 58.6958 188.967 59.0584 188.692C59.1088 188.761 59.1894 188.803 59.28 188.796C60.6451 188.702 62.0051 188.768 63.3399 188.99C64.0476 189.105 64.7453 189.267 65.4379 189.471C67.2587 190.01 68.9638 190.828 70.5127 191.909C70.5152 191.914 70.5177 191.916 70.5227 191.919C70.5278 191.921 70.5303 191.924 70.5353 191.926C70.7721 192.09 71.0038 192.261 71.233 192.44C70.9534 192.709 70.6789 192.989 70.4119 193.271C67.9967 191.705 65.3673 190.622 62.5995 190.052Z",
    fill: "#0E171E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2417 190.426L70.2417 190.426L70.2444 190.423C70.4487 190.226 70.683 190.06 70.9385 189.931C71.0803 190.07 71.2114 190.212 71.3309 190.356C71.17 190.458 71.0171 190.572 70.8744 190.699L70.8741 190.699C70.7604 190.801 70.6523 190.909 70.5514 191.024C70.3719 190.904 70.1904 190.789 70.0075 190.677C70.0804 190.588 70.1586 190.504 70.2417 190.426Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3814 191.603C71.4314 191.55 71.4839 191.5 71.5385 191.451C71.6514 191.353 71.7714 191.264 71.8976 191.186C71.9336 191.252 71.9668 191.315 71.9971 191.376C71.9935 191.379 71.9899 191.382 71.9863 191.386L71.9862 191.386C71.852 191.507 71.7172 191.631 71.584 191.756C71.5169 191.704 71.4494 191.653 71.3814 191.603Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M69.302 196.26L69.3016 196.261C68.4385 197.402 67.6922 198.639 67.0881 199.938C66.8536 199.953 66.6015 199.965 66.3293 199.973C67.0181 198.779 67.7904 197.622 68.6221 196.528C69.7518 195.044 71.0155 193.651 72.3844 192.38C72.4342 192.564 72.473 192.745 72.5014 192.925C72.4955 192.929 72.4896 192.934 72.4838 192.939L72.4838 192.939L72.4819 192.94C71.2986 193.922 70.2302 195.039 69.302 196.26Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6866 198.016C71.0588 197.55 71.4714 197.123 71.9216 196.738C71.662 197.319 71.4172 197.686 71.3833 197.736C71.1362 198.092 70.7998 198.575 70.2039 199.028C70.0857 199.118 69.9666 199.2 69.8425 199.274C70.0898 198.833 70.3724 198.411 70.6866 198.016Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5054 199.711L68.5054 199.711L68.503 199.717C68.4957 199.735 68.4893 199.753 68.4839 199.772C68.4142 199.786 68.3424 199.799 68.2682 199.811C68.7874 198.778 69.4035 197.79 70.1046 196.867L70.1048 196.867C70.8362 195.903 71.6634 195.006 72.5664 194.197C72.548 194.52 72.5042 194.831 72.4441 195.126C72.3979 195.14 72.3531 195.16 72.3113 195.188C71.3956 195.794 70.5854 196.535 69.904 197.391C69.3387 198.099 68.8691 198.881 68.5054 199.711Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M211.261 190.747C211.026 189.445 210.591 188.158 209.974 186.904C210.815 185.536 211.636 183.683 211.782 181.439C211.968 178.578 210.996 176.127 210.535 174.968C209.095 171.339 206.919 169.236 207.468 166.982C207.533 166.715 207.717 165.96 208.349 165.584C209.115 165.129 210.092 165.499 210.475 165.645C212.394 166.37 215.149 170.118 216.003 174.56C217.393 181.804 213.213 188.186 211.261 190.747Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M184.137 166.519C184.2 164.889 184.338 163.285 184.666 163.265C184.703 163.262 184.734 163.287 184.754 163.305C185.419 163.907 185.95 165.834 186.973 166.466C187.172 166.589 187.489 166.723 187.977 166.723C188.038 166.083 188.202 165.592 188.343 165.265C188.443 165.03 188.914 163.927 189.363 163.985C189.441 163.995 189.494 164.035 189.526 164.066C190.37 164.783 190.753 167.428 190.753 167.43C190.997 169.138 191.121 169.992 191.345 170.649C191.743 171.818 192.345 172.664 192.768 173.178C200.958 176.399 207.244 181.353 209.974 186.904",
    fill: "#0E171E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M184.137 166.519C184.2 164.889 184.338 163.285 184.666 163.265C184.703 163.262 184.734 163.287 184.754 163.305C185.419 163.907 185.95 165.834 186.973 166.466C187.172 166.589 187.489 166.723 187.977 166.723C188.038 166.083 188.202 165.592 188.343 165.265C188.443 165.03 188.914 163.927 189.363 163.985C189.441 163.995 189.494 164.035 189.526 164.066C190.37 164.783 190.753 167.428 190.753 167.43C190.997 169.138 191.121 169.992 191.345 170.649C191.743 171.818 192.345 172.664 192.768 173.178C200.958 176.399 207.244 181.353 209.974 186.904",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M211.262 190.747C211.387 191.447 211.455 192.155 211.463 192.863C211.476 194.243 211.259 195.867 210.566 197.688",
    fill: "#0E171E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M211.262 190.747C211.387 191.447 211.455 192.155 211.463 192.863C211.476 194.243 211.259 195.867 210.566 197.688",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M184.137 166.519C183.522 166.583 181.969 166.83 180.585 168.055C180.064 168.516 178.603 169.809 178.683 171.438C178.743 172.678 179.639 172.952 180.766 175.268C180.766 175.268 181.165 176.09 181.696 177.723C182.481 180.134 183.196 187.091 183.057 196.427",
    fill: "#0E171E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M184.137 166.519C183.522 166.583 181.969 166.83 180.585 168.055C180.064 168.516 178.603 169.809 178.683 171.438C178.743 172.678 179.639 172.952 180.766 175.268C180.766 175.268 181.165 176.09 181.696 177.723C182.481 180.134 183.196 187.091 183.057 196.427",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M188.479 181.233C188.23 183.062 187.97 184.621 187.75 185.835C187.496 187.236 186.533 192.382 184.844 194.184C184.693 194.345 184.534 194.522 184.219 194.878C183.171 196.062 183.012 196.335 182.921 196.655C182.84 196.936 182.688 197.471 182.939 197.892C183.122 198.197 183.539 198.477 185.95 198.5C186.636 198.507 187.57 198.494 188.684 198.409",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M197.773 183.898C197.05 184.138 195.065 184.902 193.65 186.951C191.565 189.969 192.42 193.309 192.557 193.808C192.449 193.816 192.243 193.836 191.99 193.882C189.878 194.274 187.957 195.927 187.887 197.338C187.869 197.688 187.973 197.876 188.023 197.954C188.351 198.455 189.166 198.46 189.55 198.455C190.825 198.438 198.985 198.126 210.566 197.688",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M186.166 171.438C186.653 171.549 187.185 171.693 187.749 171.883C188.316 172.073 188.829 172.28 189.287 172.486",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M186.178 172.543C186.511 172.635 186.985 172.805 187.488 173.135C188.01 173.478 188.363 173.861 188.581 174.138",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M183.204 169.707C183.085 170.097 183.269 170.516 183.626 170.687C184.003 170.866 184.471 170.72 184.685 170.345",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.008 169.889C181.935 170.059 181.963 170.217 182.031 170.253C182.103 170.291 182.268 170.217 182.361 170.025",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M180.221 169.365C180.391 169.618 180.686 169.752 180.972 169.706C181.315 169.652 181.586 169.35 181.61 168.978",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M145.617 183.813L153.648 197.781C159.092 194.518 164.537 191.255 169.981 187.991C170.688 187.568 170.5 186.495 169.691 186.338L165.122 185.45C164.72 185.372 164.369 185.129 164.155 184.78L157.969 174.834L145.617 183.813Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M147.502 186.585C151.945 183.938 156.057 181.487 160.5 178.84",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M148.848 189.307C149.641 189.25 152.255 189.164 154.77 190.917C156.74 192.289 157.625 194.075 157.96 194.865",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M169.139 183.748C168.814 184.069 168.344 184.465 167.711 184.811C166.859 185.277 166.067 185.456 165.539 185.531",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M165.266 185.176C164.426 183.863 164.355 182.476 165.007 181.776C165.142 181.63 165.389 181.428 165.828 181.319C166.194 181.271 166.617 181.391 166.876 181.683C167.281 182.14 167.115 182.813 167.028 183.156C166.722 184.366 165.611 184.997 165.266 185.176Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M145.617 183.813C149.735 180.82 153.852 177.827 157.969 174.834C158.417 175.598 158.865 176.363 159.313 177.127C155.005 179.78 150.697 182.432 146.389 185.085C146.132 184.661 145.874 184.237 145.617 183.813Z",
    fill: "#0E171E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M114.062 184.387L111.707 199.672C117.988 200.59 124.268 201.508 130.549 202.426C131.364 202.545 131.897 201.595 131.37 200.962L128.394 197.383C128.132 197.068 128.014 196.658 128.068 196.253L129.593 184.902L114.062 184.387Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M113.65 187.058C118.766 187.818 123.881 188.579 128.997 189.34",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M113.352 190.073C114.002 190.532 116.08 192.119 116.919 195.067C117.577 197.376 117.132 199.319 116.891 200.143",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M132.582 198.606C132.127 198.649 131.512 198.659 130.804 198.526C129.849 198.347 129.123 197.985 128.666 197.709",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 197.262C128.86 195.714 129.682 194.595 130.63 194.465C130.827 194.438 131.146 194.437 131.555 194.631C131.868 194.825 132.12 195.186 132.136 195.576C132.161 196.186 131.606 196.602 131.322 196.813C130.319 197.556 129.06 197.342 128.68 197.262Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M114.238 184.387C119.32 184.674 124.51 184.615 129.592 184.902C129.455 185.778 129.297 186.387 129.16 187.262C124.146 186.591 119.131 185.919 114.117 185.248C114.186 184.757 114.169 184.878 114.238 184.387Z",
    fill: "#0E171E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3118 136.527L69.8613 142.253C69.254 149.972 75.4702 156.515 83.2102 156.304L119.225 155.323L113.009 184.355L131.537 184.902L134.513 163.944L144.536 184.598L159.662 173.603L142.386 143.579C139.883 139.229 135.247 136.548 130.229 136.548H100.921L70.3118 136.527Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M120.664 136.537C122.075 136.532 123.486 136.527 124.897 136.523C131.952 136.499 137.401 142.717 136.45 149.708L134.514 163.945",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M134.512 163.945C135.211 158.468 135.911 152.991 136.61 147.514C136.728 147.602 137.049 162.101 137.092 169.261C136.232 167.489 135.372 165.717 134.512 163.945Z",
    fill: "#0E171E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3164 87.5131L95.0282 81.3907C95.0282 81.3907 96.011 77.9476 98.4603 76.0451C102.131 73.1941 106.483 74.2316 107.041 74.3746C107.673 74.4252 108.939 73.0078 108.939 73.0078C108.939 73.0078 108.886 75.9854 108.86 76.7148C108.829 77.2949 108.895 78.0324 109.351 78.6447C109.679 79.0857 110.043 79.2384 110.032 79.538C110.023 79.801 109.727 80.1511 108.483 80.5403C108.489 81.3174 108.494 82.0944 108.499 82.8715C108.507 84.1085 107.526 85.1259 106.29 85.1631C104.672 85.2117 101.437 85.3089 101.437 85.3089L100.034 88.1449",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7227 79.5685C87.9257 78.6875 89.5816 78.7187 91.7319 77.5335C93.1647 76.7438 93.9252 75.9055 94.3972 75.4909C95.8807 74.1875 99.505 72.7496 108.573 72.165C109.106 73.3124 108.901 74.6467 108.156 75.6048C107.308 76.6953 105.439 76.819 104.238 76.5843C103.275 76.3961 102.613 75.9348 101.991 76.3055C101.508 76.5931 101.373 77.1877 101.35 77.3001C101.171 78.1756 101.83 78.6734 101.96 79.4318C102.194 80.7994 100.558 82.1547 100.16 82.4843C97.0971 85.0223 91.6485 83.8054 88.8389 81.3681C88.3959 80.9838 87.5653 80.2512 87.7227 79.5685Z",
    fill: "#0E171E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8438 75.7413C95.4754 72.7696 97.7645 70.4278 100.691 69.7578C103.461 69.1234 106.38 70.0848 108.269 72.2484C103.794 73.4127 99.3187 74.577 94.8438 75.7413Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M108.27 72.2482C110.107 71.7419 111.945 71.2357 113.782 70.7295C113.732 70.938 113.386 72.289 112.097 72.9315C110.89 73.5325 109.352 73.2681 108.27 72.2482Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M102.832 77.5635C102.948 77.6728 103.113 77.8079 103.333 77.928C103.559 78.0514 103.768 78.1181 103.925 78.1558",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M102.832 77.5635C102.948 77.6728 103.113 77.8079 103.333 77.928C103.559 78.0514 103.768 78.1181 103.925 78.1558",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M106.068 80.373C106.123 80.4671 106.273 80.6969 106.57 80.8438C106.821 80.9686 107.052 80.9712 107.162 80.9653",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M106.068 80.373C106.123 80.4671 106.273 80.6969 106.57 80.8438C106.821 80.9686 107.052 80.9712 107.162 80.9653",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M106.915 79.5175C107.819 79.5175 108.553 78.7843 108.553 77.8798C108.553 76.9754 107.819 76.2422 106.915 76.2422C106.011 76.2422 105.277 76.9754 105.277 77.8798C105.277 78.7843 106.011 79.5175 106.915 79.5175Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M106.402 78.0194C106.439 78.0518 106.645 78.2252 106.949 78.2017C107.271 78.1767 107.453 77.9495 107.481 77.9131",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M101.395 85.0693H99.2917C99.1291 85.0693 99.0132 85.2272 99.0621 85.3824L99.8986 88.0392L101.395 85.0693Z",
    fill: "#0E171E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M127.406 119.751L134.058 118.453C134.058 118.453 135.534 118.244 136.655 118.385C138.27 118.587 144.273 120.908 144.527 121.638C144.605 121.863 144.584 122.083 144.584 122.083C144.539 122.544 144.172 122.847 144.058 122.941C143.656 123.273 142.936 123.379 141.347 122.986C140.477 122.771 139.273 122.388 137.908 121.665",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M137.816 125.993C138.123 125.995 138.817 125.95 139.252 125.469C139.907 124.744 139.79 123.23 138.648 122.032",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M136.71 126.748C136.896 126.688 137.439 126.484 137.74 125.942C138.134 125.232 137.82 124.47 137.694 124.165C137.179 122.916 135.858 122.503 135.621 122.434",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M133.83 127.154C133.489 127.034 132.898 126.881 132.19 126.995C131.75 127.065 130.965 127.191 130.754 127.747C130.633 128.068 130.733 128.451 130.918 128.708C131.414 129.396 132.593 129.274 133.26 129.205C134.133 129.114 135.364 128.986 136.13 127.952C136.266 127.769 136.935 126.866 136.632 125.81C136.364 124.879 135.443 124.183 134.308 124.079",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M131.712 126.107C131.463 126.52 130.952 127.245 130.049 127.839C129.036 128.504 128.157 128.66 127.668 128.704",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M127.723 128.686L129.378 128.211L127.406 119.75L127.723 128.686Z",
    fill: "#0E171E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2752 89.5255L63.7492 134.554C63.2363 135.425 63.8636 136.523 64.8742 136.524L100.92 136.548L101.199 132.967L121.624 132.585C122.944 132.561 123.986 131.453 123.929 130.133L123.396 117.747L102.254 119.429L104.089 95.8879C104.37 92.2836 102.189 88.9416 98.7771 87.7465L96.9174 87.0951C94.4071 86.2159 91.6253 87.2337 90.2752 89.5255Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4492 136.452L70.0336 140.042L70.3101 136.528L64.4492 136.452Z",
    fill: "#0E171E"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2324 119.843C99.7875 119.688 101.343 119.533 102.898 119.378",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4431 105.173L87.9793 120.771C86.9629 127.206 91.9608 133.016 98.4754 132.974L102.104 132.95",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M96.82 132.857C96.8324 131.997 96.5486 130.509 95.7262 128.621C93.7485 124.08 88.593 123.925 87.8965 123.706",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M123.929 130.133C123.752 126.005 123.574 121.876 123.396 117.747C124.662 117.608 125.927 117.469 127.192 117.33C127.369 121.566 127.546 125.803 127.723 130.039C126.459 130.07 125.194 130.102 123.929 130.133Z",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M127.313 120.207C126.047 120.292 124.78 120.377 123.514 120.461",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M123.656 123.784C124.922 123.723 126.188 123.661 127.454 123.599",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M123.783 126.748C125.051 126.761 126.319 126.774 127.587 126.787",
    stroke: "#0E171E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs2);
export default __webpack_public_path__ + "static/media/cs2.bffa5c5554ad090bff78e70b62bcfa00.svg";
export { ForwardRef as ReactComponent };